import vue from "vue";
const InputSearch = () => import(/* webpackPrefetch: true */'./InputSearch.vue')

vue.component("InputSearch", InputSearch);